module.exports = __webpack_public_path__ + "img/tg-1.a248ad30.png";